import React, { useState } from "react";
import Swal from "sweetalert2";
import { FieldArray, useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import Illustration from "../../../../../partials/content/Illustration";
import { DialogActions } from "@material-ui/core";
import SearchItemUom from "../../items/searchItemUom";
import SearchVariant from "../../items/searchVariant";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";

function SafeStockItemDetFormContent({
  safeStockID = 0,
  item = { itemID: 0, uomID: 0 },
  warehouseID = 0,
  outletID = 0,
}) {
  const { values, setFieldValue } = useFormikContext();
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openSearchVariant, setOpenSearchVariant] = useState(false);
  return (
    <React.Fragment>
      <FieldArray name="data">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.data && values.data.length > 0 ? (
                      <thead className="text-center">
                        <th style={{ width: "45%" }}>Variant</th>
                        <th style={{ width: "20%" }}>Unit</th>
                        <th style={{ width: "15%" }}>Safety Stock</th>
                        <th style={{ width: "15%" }}>Request Quantity</th>
                        <th>Actions</th>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.data && values.data.length > 0 ? (
                        values.data.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="data"
                                  index={index}
                                  propName="variantName"
                                  value={item.variantName}
                                  margin="none"
                                  searchButton
                                  clearButton
                                  readonly
                                  onSearchClick={() => {
                                    setSelectedIndex(index);
                                    setOpenSearchVariant(true);
                                  }}
                                  onClearFields={() => {
                                    setFieldValue(
                                      `data[${index}].variantName`,
                                      "No Variant"
                                    );
                                    setFieldValue(`data[${index}].varCode`, "");
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="data"
                                  index={index}
                                  propName="uomName"
                                  margin="none"
                                  value={item.uomName}
                                  searchButton
                                  readonly
                                  onSearchClick={() => {
                                    setSelectedIndex(index);
                                    setOpenSearchUom(true);
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="data"
                                  index={index}
                                  propName="qty"
                                  quantityField
                                  margin="none"
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="data"
                                  index={index}
                                  propName="requestQty"
                                  quantityField
                                  margin="none"
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                <BootstrapTooltip
                                  title={
                                    item.deleteInd
                                      ? "Undo Delete"
                                      : "Delete Safe Stock Item"
                                  }
                                >
                                  <button
                                    type="button"
                                    className={`btn btn-icon btn-label-${
                                      item.deleteInd ? "warning" : "danger"
                                    } btn-md btn-circle mx-1`}
                                    onClick={() => {
                                      if (item.ID > 0) {
                                        setFieldValue(
                                          `data[${index}].deleteInd`,
                                          !item.deleteInd
                                        );
                                      } else {
                                        remove(index);
                                      }
                                    }}
                                  >
                                    {item.deleteInd ? (
                                      <i className="fas fa-undo-alt"></i>
                                    ) : (
                                      <i className="fas fa-trash-alt"></i>
                                    )}
                                  </button>
                                </BootstrapTooltip>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td className="text-center py-3" colSpan="5">
                            <Illustration
                              imageSource="INVIFO Inventory.png"
                              guidance="You don't have any Safe Stock items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="text-center py-3" colSpan="5">
                          <button
                            type="button"
                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                            onClick={() => {
                              push({
                                ID: 0,
                                safeStockID,
                                warehouseID,
                                outletID,
                                itemID: item.itemID,
                                itemCode: item.itemCode,
                                varCode: "",
                                itemName: "",
                                variantName: "No Variant",
                                qty: 0,
                                requestQty: 0,
                                uomID: 0,
                                uomName: "",
                                deleteInd: false,
                              });
                            }}
                          >
                            <i className="fas fa-plus-circle"></i>
                            Add Safe Stock Item
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchUom}
        title="Search Unit of Measurement"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        maxWIdth="sm"
      >
        <SearchItemUom
          itemID={item.itemID}
          onSelectUom={(uom) => {
            if (
              values.data[selectedIndex].varCode === "" &&
              uom.ID === item.uomID
            ) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text:
                  "Unable to select item Base Unit with No Variant combination. Please pick any Variant first before select item Base Unit",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            } else {
              setFieldValue(`data[${selectedIndex}].uomID`, uom.ID);
              setFieldValue(`data[${selectedIndex}].uomName`, uom.uomName);
            }
            setOpenSearchUom(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchVariant}
        title="Search Variant"
        onCloseDialog={() => {
          setOpenSearchVariant(false);
        }}
        maxWIdth="sm"
      >
        <SearchVariant
          itemID={item.itemID}
          onSelectVariant={(varCode, valueName) => {
            setFieldValue(`data[${selectedIndex}].varCode`, varCode);
            setFieldValue(`data[${selectedIndex}].variantName`, valueName);
            setOpenSearchVariant(false);
          }}
          onCloseDialog={() => {
            setOpenSearchVariant(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default SafeStockItemDetFormContent;
